import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import { fetchPayoutReceiveWallets, fetchPayoutWallets } from '../../api';

const useFetchPayoutWallets = () => {
  const { tab } = useParams();

  const [wallets, setWallets] = useState([]);
  const [walletsToDisplay, setWalletsToDisplay] = useState(wallets);

  const { isLoading, data, isError, refetch } = useQuery('allPayoutWallets', fetchPayoutWallets);
  if (isError) {
    toast.error('Error fetching payout wallets');
  }

  useEffect(() => {
    if (data && data.data) {
      setWallets(data.data);
    } else {
      setWallets([]);
    }
  }, [data]);

  useEffect(() => {
    const filteredWallets = wallets.filter((wallet) => {
      const { type } = wallet;
      if (!tab || tab === 'all' || tab === type?.toLowerCase()) return wallet;
    });
    setWalletsToDisplay(filteredWallets);
  }, [tab, wallets]);

  return { isLoading, refetch, wallets, walletsToDisplay };
};

const useFetchPayoutReceiveWallets = () => {
  const [wallets, setWallets] = useState([]);

  const { isLoading, data, isError } = useQuery(
    'allPayoutReceiveWallets',
    fetchPayoutReceiveWallets
  );
  if (isError) {
    toast.error('Error fetching payout receive wallets');
  }

  useEffect(() => {
    if (data && data.data) {
      setWallets(data.data);
    } else {
      setWallets([]);
    }
  }, [data]);

  return { isLoading, wallets };
};

export { useFetchPayoutReceiveWallets, useFetchPayoutWallets };
